// Action type controls the notification text displayed to the user
export enum TrialActionType {
  Search = "Search",
  Chat = "Chat",
  Stacks = "Stacks",
  Connector = "Connector",
}

export type TrialActivityData = {
  lastSearchDate: number | undefined;
};
